import { Result, Select } from "antd";
import Loader from "Common/Loader";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  Summary,
  TotalItem,
} from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import useHasPermission from "hooks/useHasPermission";
import { getBillSettingById } from "pages/Componets/API_Modal/BillSettingMasterAPIModal";
import { getAllStoreForSelect } from "pages/Componets/API_Modal/StoreMasterAPIModal";
import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";

type Type = {
  text: any;
  value: any;
};

const BillSettingMaster: React.FC = () => {
  const hasPermission = useHasPermission();

  const dataGridRef = useRef<any>(null);
  const [storeData, setStoreData] = useState<Type[]>([]);
  const [selectedId, setSelectedId] = useState("");
  const [pagination, setPagination] = useState({ pageSize: 10, pageNumber: 1 });
  const [dataGridFilter, setDataGridFilter] = useState<{
    showFilterRow: boolean;
    showHeaderFilter: boolean;
    currentFilter: "auto" | "onClick";
  }>({
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: "auto",
  });

  const getStoredetails = async () => {
    try {
      const response = await getAllStoreForSelect();
      setStoreData(response?.data || []);
      if (response?.data) {
        setSelectedId(response?.data[0].value);
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  useEffect(() => {
    getStoredetails();
  }, []);

  const dataSource = React.useMemo(() => {
    return new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        try {
          const params = new URLSearchParams();
          params.set("skip", String(loadOptions.skip ?? 0));
          params.set(
            "take",
            String(loadOptions.take ?? pagination.pageNumber * 10)
          );
          params.set("sort", JSON.stringify(loadOptions.sort ?? []));
          params.set("filter", JSON.stringify(loadOptions.filter ?? null));
          params.set(
            "searchExpr",
            JSON.stringify(loadOptions.searchExpr ?? null)
          );
          params.set("searchOperation", loadOptions.searchOperation ?? "");
          params.set("searchValue", loadOptions.searchValue ?? "");

          let response = null;
          if (selectedId) {
            response = await getBillSettingById(params, selectedId);
          }
          if (!response?.data || response.data.length === 0) {
            return { data: [], totalCount: 0 };
          }

          return response.data.reverse();
        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      },
    });
  }, [selectedId]);

  const onPagingChange = ({
    pageSize,
    pageIndex,
  }: {
    pageSize?: number;
    pageIndex?: number;
  }) => {
    setPagination({
      pageSize: pageSize ?? pagination.pageSize,
      pageNumber: (pageIndex ?? pagination.pageNumber - 1) + 1,
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">Bill Setting Master</h5>
            </Card.Header>
            <Card.Body>
              {hasPermission("BillSetting.Read") ? (
                <>
                  <div className="row mt-3 mb-3  col-md-2">
                    <Select
                      id="storeId"
                      value={
                        selectedId
                          ? storeData.find((x) => x.value == selectedId)?.value
                          : undefined
                      }
                      onChange={(value) => {
                        setSelectedId(value);
                      }}
                      placeholder="Select store"
                      options={storeData?.map((type) => ({
                        label: type.text,
                        value: type.value,
                      }))}
                      // allowClear
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                  </div>
                  <DataGrid
                    ref={dataGridRef}
                    dataSource={dataSource}
                    remoteOperations={{
                      paging: true,
                      filtering: true,
                      sorting: true,
                    }}
                    onOptionChanged={(e) => {
                      if (
                        e.fullName === "paging.pageIndex" ||
                        e.fullName === "paging.pageSize"
                      ) {
                        onPagingChange({
                          pageIndex:
                            e.fullName === "paging.pageIndex"
                              ? e.value
                              : pagination.pageNumber - 1,
                          pageSize:
                            e.fullName === "paging.pageSize"
                              ? e.value
                              : pagination.pageSize,
                        });
                      }
                    }}
                    showRowLines={true}
                    keyExpr="id"
                    columnAutoWidth={true}
                    showBorders={true}
                    onContentReady={(e) => {
                      const hasData = e.component.totalCount() > 0;
                      e.component.option("pager.visible", hasData);
                      e.component.option("paging.visible", hasData);
                    }}
                  >

                    <Scrolling
                      mode="standard"
                      useNative={true}
                      scrollByContent={true}
                      scrollByThumb={true}
                    />

                    <Pager
                      showPageSizeSelector
                      allowedPageSizes={[10, 25, 50, 100]}
                      showNavigationButtons
                      displayMode="full"
                      showInfo
                    />
                    <Summary>
                      <TotalItem
                      // column="serialNo"
                      // summaryType="count"
                      // displayFormat="Total Bill Settings: {0}"
                      />
                    </Summary>

                    <Paging pageSize={pagination?.pageSize} />

                    {/* <HeaderFilter visible={dataGridFilter?.showHeaderFilter} /> */}
                    <Column
                      dataField="id"
                      dataType="number"
                      sortOrder="desc"
                      visible={false}
                      allowFiltering={false}
                    />
                    <Column
                      caption="Sr.No."
                      dataType="number"
                      alignment="center"
                      width={100}
                      cellRender={(e) => {
                        const rowIndex =
                          e.rowIndex +
                          1 +
                          e.component.pageIndex() * e.component.pageSize();
                        return <span>{rowIndex}</span>;
                      }}
                    />

                    <Column
                      dataField="serialNo"
                      caption="Bill Serial No"
                      dataType="string"
                    />
                    <Column
                      dataField="billType"
                      caption="Bill Type"
                      width={150}
                      dataType="string"
                    />
                    <Column
                      dataField="initial"
                      caption="Initial"
                      dataType="string"
                    />
                    <Column
                      dataField="prefix"
                      caption="Prefix"
                      dataType="string"
                    />
                    <Column
                      dataField="storeName"
                      caption="Store Name"
                      dataType="string"
                    />
                    <Column dataField="year" caption="Year" dataType="string" />
                  </DataGrid>
                </>
              ) : (
                null
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BillSettingMaster;
